import { formatted_date_for_backend } from "../../helper/Generic/dateTimeFormat";
import { POST } from "../APiHelper/API";

export let getGamesRequest;

export const getGamesAtackAndDefenceApiCall = (
    data,
    onSuccess,
    onError
) => {

    getGamesRequest = POST(`/api/v1/games/attack_and_defence`, data, onSuccess, onError, true, getGamesRequest);
};
